import type { ProfilePersonal } from '@dxtech/shared';
import { call } from './library.js';

// 혈액형·MBTI — 임직원 보드 표시(전 임직원) / 내 정보 수정(본인)
export type PersonalItem = { upn: string } & ProfilePersonal;
export const personalApi = {
  list: async () => (await (await call('/profile/personal')).json()) as { items: PersonalItem[] },
  save: (body: Required<ProfilePersonal>) => call('/profile/personal', body),
};
/** 'A' + 'ENTJ' → 'A형 · ENTJ' */
export const personalText = (p?: ProfilePersonal): string =>
  [p?.bloodType ? `${p.bloodType}형` : '', p?.mbti ?? ''].filter(Boolean).join(' · ');
